export const updateCompleteProfileRouteReducer = {
  updateCompleteProfileRoute: (state, action) => {
    console.log('Update profile path called', action.payload);
    state.completeProfileRoute = action.payload;
  },
};
